import { CAT_ATTENDING_REQUESTS } from 'App/utils/Collections';
import { FT_AUTOCOMPLETE, FT_LIST, FT_DATE } from '../FilterTypes';

import { searchCustomers, statusItemsLoader } from './loaders';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  tracking: {
    name: 'Tracking',
    groupOrderIndex: 1,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_ATTENDING_REQUESTS,
  filters: [
    {
      id: 'status.id',
      label: 'Status',
      type: FT_LIST,
      group: groups.general,
      getListItems: () => statusItemsLoader(2),
    },
    {
      id: 'customer.id',
      label: 'Customer',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: searchCustomers,
      },
    },
    {
      id: 'createdAt',
      label: 'Created at',
      group: groups.date,
      type: FT_DATE,
    },
  ],
  searchBarProp: 'complex_name',
};
